/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/segments-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/segments-api-client";
import type { StationStatusGetStatusesQueryResponse, StationStatusGetStatusesQueryParams } from "../models/StationStatusGetStatuses";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { stationStatusGetStatuses } from "../axios/stationStatusGetStatuses";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const stationStatusGetStatusesQueryKey = (params?: StationStatusGetStatusesQueryParams) => ["segments-api", { url: '/status' }, ...(params ? [params] : [])] as const

export type StationStatusGetStatusesQueryKey = ReturnType<typeof stationStatusGetStatusesQueryKey>

export function stationStatusGetStatusesQueryOptions(params?: StationStatusGetStatusesQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = stationStatusGetStatusesQueryKey(params)
  return queryOptions<StationStatusGetStatusesQueryResponse, ResponseErrorConfig<Error>, StationStatusGetStatusesQueryResponse, typeof queryKey>({
 
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return stationStatusGetStatuses(params, config)
   },
  })
}

/**
 * @description Returns status (online/offline) and recent segments info for stations. A station is online if it has recorded a segment in the past threshold seconds. Includes latestAt (ISO string) indicating the most recent segment endTs. If ids query parameter is provided, returns status for those specific stations. If omitted, returns status for all stations of the client.
 * @summary Get status for stations
 * {@link /status}
 */
export function useStationStatusGetStatuses<TData = StationStatusGetStatusesQueryResponse, TQueryData = StationStatusGetStatusesQueryResponse, TQueryKey extends QueryKey = StationStatusGetStatusesQueryKey>(params?: StationStatusGetStatusesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<StationStatusGetStatusesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? stationStatusGetStatusesQueryKey(params)

  const query = useQuery({
   ...stationStatusGetStatusesQueryOptions(params, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}